<template>
  <div
    v-if="config"
    class="modal"
    :class="{'is-active': config}"
  >
    <div
      class="modal-background"
      @click="clickCloseButton"
    />
    <div class="modal-card">
      <header
        class="modal-card-head"
        :class="config.header.class"
      >
        <p
          class="modal-card-title"
          :class="config.title.class"
        >
          {{ config.title.content }}
        </p>
        <button
          class="delete"
          aria-label="close"
          @click="clickCloseButton"
        />
      </header>
      <section
        class="modal-card-body"
        :class="config.body.class"
      >
        {{ config.body.content }}
      </section>
      <footer class="modal-card-foot">
        <button
          v-if="config.leftButton"
          class="button"
          :class="config.leftButton.class"
          @click="clickLeftButton"
        >
          {{ config.leftButton.content }}
        </button>
        <button
          v-if="config.rightButton"
          class="button"
          :class="config.rightButton.class"
          @click="clickRightButton"
        >
          {{ config.rightButton.content }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {
          title: {
            content: 'Message',
          },
          body: {
            content: 'Message text.',
          },
        };
      },
    },
  },
  methods: {
    clickCloseButton() {
      if (this.config.closeButton && this.config.closeButton.emits) {
        Object.values(this.config.closeButton.emits).forEach((emit) => this.$emit(emit.event, emit.value));
      }
    },
    clickLeftButton() {
      if (this.config.leftButton && this.config.leftButton.emits) {
        Object.values(this.config.leftButton.emits).forEach((emit) => this.$emit(emit.event, emit.value));
      }
    },
    clickRightButton() {
      if (this.config.rightButton && this.config.rightButton.emits) {
        Object.values(this.config.rightButton.emits).forEach((emit) => this.$emit(emit.event, emit.value));
      }
    },
  },
};
</script>
